import React from 'react'

const SuccessModal = ( { children, title, hideModal } ) => {
  return (
    <div tabIndex="-1" aria-hidden="true" className="fixed top-0 left-0 right-0 bottom-0 z-50 w-full p-4 overflow-x-hidden overflow-y-auto md:inset-0 h-[100%] max-h-full bg-black-overlay flex justify-center items-center">
      <div className="relative w-full max-w-2xl max-h-full m-auto">
        <div className="relative bg-white rounded-lg shadow">
          <div className="flex items-start justify-between p-4 rounded-t bg-success mb-2">
            <h1 className="text-2xl font-bold leading-tight tracking-tight text-white md:text-2xl text-center">
              { title }
            </h1>
            <button type="button" className="bg-transparent rounded-lg text-sm w-8 h-8 ml-auto inline-flex justify-center items-center" onClick={() => hideModal(false)}>
              <svg className="w-3 h-3" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 14 14">
                <path stroke="#fff" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="m1 1 6 6m0 0 6 6M7 7l6-6M7 7l-6 6" />
              </svg>
              <span className="sr-only">Close modal</span>
            </button>
          </div>
          { children }
        </div>
      </div>
    </div>
  )
}

export default SuccessModal;